import React from "react";

const OfflineRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 4,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.2433 8.759C15.9246 8.8834 17.25 10.2869 17.25 12C17.25 13.7949 15.7949 15.25 14 15.25H8.31594M11.8458 5.17067C11.2876 4.9011 10.6614 4.75 10 4.75C7.73368 4.75 5.88168 6.5239 5.75672 8.759C4.07542 8.8834 2.75 10.2869 2.75 12C2.75 12.3489 2.80498 12.685 2.90675 13",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.25 3.75L3.75 16.25",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(OfflineRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;